<template>
  <div id="ListDetailMemberData" class="well" style="padding: 0 1em">
    <div class="course_title">檢視詳細會員資料</div>

    <div class="form-group">
      <table class="table" style="width: auto; align: left">
        <tbody>
          <tr>
            <td colspan="4" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。</span
              >
            </td>
          </tr>
          <tr align="left">
            <td>公司名稱</td>
            <td>{{ queryInfo.ComName }}</td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>會員性別</td>
            <td>{{ Sex_Array[queryInfo.Sex] }}</td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>生日</td>
            <td>{{ Y1 }}年{{ M1 }}月{{ D1 }}日</td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>身分證字號(帳號)</td>
            <td>{{ $props.IdNo }}</td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>公司電子信箱</td>
            <td>
              <input
               type="email"
                class="form-control"
                v-model="queryInfo.ComEmail"
                placeholder="公司電子信箱"
                required
              />
            </td>
            <td><span class="red_star">範例(0412345678)</span></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>公司連絡電話</td>
            <td>
              <input
                type="Number"
                class="form-control"
                v-model="queryInfo.ComTel"
                placeholder="公司連絡電話"
                required
              />
            </td>
            <td><span class="red_star">範例(0412345678)</span></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>連絡人電話</td>
            <td>
              <input
                type="Number"
                class="form-control"
                v-model="queryInfo.PhoneNo1"
                placeholder="連絡電話"
                required
              />
            </td>
            <td><span class="red_star">範例(0412345678)</span></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>連絡人行動電話</td>
            <td>
              <input
                type="Number"
                class="form-control"
                v-model="queryInfo.PhoneNo2"
                placeholder="行動電話"
                pattern="/^-?\d+\.?\d*$/"
                onKeyPress="if(this.value.length==10) return false;"
                required
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>連絡人電子信箱</td>
            <td>{{ queryInfo.EMail }}</td>
            <td></td>
            <td></td>
          </tr>

          <tr align="left">
            <td><span class="red_star">＊</span>交通工具</td>
            <td>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="0"
                  id="inlineCheckbox0"
                />
                <label class="form-check-label" for="0">公車</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="1"
                  id="inlineCheckbox1"
                />
                <label class="form-check-label" for="1">機車</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="2"
                  id="inlineCheckbox2"
                />
                <label class="form-check-label" for="2">汽車</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="3"
                  id="inlineCheckbox3"
                />
                <label class="form-check-label" for="3">步行</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="4"
                  id="inlineCheckbox4"
                />
                <label class="form-check-label" for="4">其他</label>
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>車牌號碼(步行、公車不需填寫)</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.PlateNumber"
                placeholder="車牌號碼(步行、公車不需填寫)"
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>飲食習慣</td>
            <td>
              <div class="input-group-text">
                <input
                  type="radio"
                  id="EatingHabits"
                  v-bind:value=true
                  v-model="queryInfo.EatingHabits"
                  aria-label="Radio button for following text input"
                />暈
                  <input
                  type="radio"
                  id="EatingHabits"
                  v-bind:value=false
                  v-model="queryInfo.EatingHabits"
                  aria-label="Radio button for following text input"
                />素

              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>服務單位/就讀學校</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.ServiceUnit"
                placeholder="服務單位/就讀學校"
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>聯絡地址</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.MailAddress"
                placeholder="聯絡地址"
              />
            </td>
            <td></td>
            <td></td>
          </tr>

          <tr align="left">
            <td>訂閱電子報</td>
            <td>
              <input
                type="checkbox"
                v-model="queryInfo.EPaper"
                aria-label="Checkbox for following text input"
                required
              />訂閱
            </td>
            <td></td>
            <td></td>
          </tr>
             <tr align="left">
            <td colspan="4" align="center"  style="background:#CCC;">密碼更換(不改密碼請勿異動)</td>

          </tr>

           <tr align="left">
            <td>新密碼</td>
            <td>
              <input
                type="password"
                class="form-control"
                v-model="newPsWord"
                placeholder="新密碼"
                minlength="8"

              />
            </td>
            <td><span class="red_star">英文數字至少8碼以上</span></td>
            <td></td>
          </tr>
           <tr align="left">
            <td>確認密碼</td>
            <td>
              <input
                type="password"
                class="form-control"
                v-model="newPsWord2"
                placeholder="確認密碼"
                minlength="8"
                @change="chkPasswd()"
              />
            </td>
            <td><span class="red_star">英文數字至少8碼以上</span></td>
            <td></td>
          </tr>
          <tr style="text-align: center">

            <td colspan="4" align="center" >
              <button
                class="btn active bg-info text-white rounded"
                @click="editMember()"
              >
                送出修改
              </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>


  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "ListDetailMemberData",
  props: ["IdNo", "PsWord"],
  data() {
    return {
      newPsWord:"",
      newPsWord2:"",
      Y1: "",
      M1: "",
      D1: "",
      Sex_Array: ["", "男", "女"],
      registerSuccessShow: 0,
      idCheckShow1: 0,
      idCheckShow: true,
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      captchaInfoArray: {
        text1: "",
        text2: "",
        text3: "",
      },
      captchaInfo: "",
      checkIdNo: "",
      attributesClassID: "", //1:現職人才培育課程/2:專業證照課程/3:創客基地課程
      queryInfo: {
        sysId: 0,
        Name: "",
        Sex: "",
        Birth: "",
        IdNo: "",
        EMail: "",
        ComName:"",
        ComEmail:"",
        ComTel:"",
        PsWord: "",
        PhoneNo1: "",
        PhoneNo2: "",
        MailAddress: "",
        VerifyCode: "",
        Agree: "",
        ServiceUnit: "",
        Transportation: "",
        TransportationArray: [],
        PlateNumber: "",
        EatingHabits: "",
        EPaper: "",
      },
    };
  },
  computed: {


  },
  methods: {
    editMember: function () {

      let vm = this;
      this.queryInfo.IdNo=vm.$props.IdNo;
this.queryInfo.Transportation=this.queryInfo.TransportationArray.toString();
if (this.newPsWord != "")
this.queryInfo.PsWord=this.newPsWord;
      this.$http
        .put("./WebApi/ociaRep/EditociaRepGeneralMember/", this.queryInfo)
        .then((response) => {
          if (0 < response.data) {
            // tools.showAlert(vm, "success", "恭喜您,存檔成功");
            // window.location.replace("http://localhost:8080/");
            alert('修改完成!!');
            window.location.replace("/");

          } else {
            alert('修改失敗!!');
            window.location.replace("/");

          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },

    chkPasswd() {
      var vm = this;
      if (vm.newPsWord != vm.newPsWord2) {
        tools.showAlert(vm, "danger", "對不起,請確認密碼是否正確");
        vm.$refs.newPsWord2.focus();
      }
      if (vm.newPsWord.length < 8 || vm.newPsWord2.length < 8) {
        tools.showAlert(vm, "danger", "對不起,請確認密碼長度是否小於8");
        vm.$refs.newPsWord2.focus();
      }

      return null;
    },
  },
  created() {
    console.log("======created ListDetailMemberData View =====");


    let vm = this;
    this.$http
      .get(
        "./WebApi/ociaRep/GetociaRepCheckLogin/".concat(
          vm.$props.IdNo + "/" + vm.$props.PsWord
        )
      )
      .then((response) => {
        if (response.data[0].name != null) {
          //   vm.queryInfo = response.data;
          vm.queryInfo.Name = response.data[0].name;
          vm.queryInfo.EMail = response.data[0].eMail;
          vm.queryInfo.ComName = response.data[0].comName;
          vm.queryInfo.ComEmail = response.data[0].comEmail;
          vm.queryInfo.ComTel = response.data[0].comTel;
          vm.queryInfo.Sex = response.data[0].sex;
          vm.queryInfo.Birth = response.data[0].birth;
          vm.queryInfo.PhoneNo1 = response.data[0].phoneNo1;
          vm.queryInfo.PhoneNo2 = response.data[0].phoneNo2;
          vm.queryInfo.PsWord = response.data[0].psWord;
          vm.queryInfo.TransportationArray = response.data[0].transportation.split(",");
          vm.queryInfo.PlateNumber = response.data[0].plateNumber;
          vm.queryInfo.EatingHabits = response.data[0].eatingHabits;
          vm.queryInfo.ServiceUnit = response.data[0].serviceUnit;
          vm.queryInfo.MailAddress = response.data[0].mailAddress;
          vm.queryInfo.EPaper = response.data[0].ePaper;

          var Birth2 = new Date(vm.queryInfo.Birth);
          vm.Y1 = Birth2.getFullYear();
          vm.M1 = Birth2.getMonth();
          vm.D1 = Birth2.getDay();
        } else {
          alert("對不起,帳號或密碼錯誤,請重新輸入");
        }
      })
      .catch(function (error) {
        alert("對不起,帳號或密碼錯誤,請重新輸入");
        // tools.showAlert(vm, "danger", "網路連線失敗" + error);
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
